<template>
  <div class="scroller" :class="getClassDirection" ref="scroller" :style="maxSize">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'Scroller',
  components: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.$refs.scroller.addEventListener('wheel', this.scrollContent.bind(this), {passive:true})
    window.addEventListener('resize', this.scrollShower.bind(this))
    this.scrollShower()
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
    this.$refs.scroller.removeEventListener('wheel', this.scrollContent.bind(this))
    window.removeEventListener('resize', this.scrollShower.bind(this))
  },
  destroyed() {},
  data() {
    return {
      showScroll: false,
      calculateWidth: -1
    }
  },
  props: {
    direction: {
      type: String,
      default: 'horizontal'
    },
    minWidth: {
      type: Number,
      default: -1
    },
    minHeight: {
      type: Number,
      default: -1
    },
    maxWidth: {
      type: Number,
      default: -1
    },
    maxHeight: {
      type: Number,
      default: -1
    },
    offset: {
      type: Number,
      default: 0
    }
  },
  computed: {
    getClassDirection() {
      return this.direction === 'horizontal' ? 'scroller-x' : 'scroller-y'
    },
    maxSize() {
      let style = ''
      if (this.showScroll) {
        if (this.direction === 'horizontal') {
          style += `padding-bottom: ${this.offset}px;`
        } else {
          style += `padding-right: ${this.offset}px;`
        }
      }
      return style
    }
  },
  methods: {
    scrollShower() {
      if (this.$refs.scroller) {
        const rect = this.$refs.scroller.getBoundingClientRect()
        if (this.direction === 'horizontal') {
          const mw = this.maxWidth !== -1 ? this.maxWidth : window.innerWidth
          this.$refs.scroller.style.maxWidth = `${mw}px`
          this.showScroll =
            this.maxWidth === -1
              ? this.$refs.scroller.scrollWidth > window.innerWidth
              : this.$refs.scroller.scrollWidth !== this.$refs.scroller.clientWidth
        } else {
          const mh = this.maxHeight !== -1 ? this.maxHeight : window.innerHeight
          this.$refs.scroller.style.maxHeight = `${mh}px`
          this.showScroll =
            this.maxHeight === -1
              ? this.$refs.scroller.scrollHeight > window.innerHeight
              : this.$refs.scroller.scrollHeight !== this.$refs.scroller.clientHeight
        }
      }
    },
    scrollContent(e, delta) {
      this.$refs.scroller.scrollLeft += e.deltaY
    }
  },
  watch: {}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/scroller/Scroller.vue